import {Action} from '@ngrx/store';
import {ArrayResponse} from '../../shared/models/array-response';
import {type} from '../../shared';
import {SiteFilter} from '../models/site-filter';
import {SelectedItem} from '../../order/models/order';
import {Site} from '../../shared/models/site';

export const siteListActionTypes = {
  TOGGLE_SEARCH: type('[sites] Toggle Search Form'),
  QUICK_SEARCH: type('[sites] Quick Search'),
  SEARCH: type('[sites] Search'),
  CHANGE_PAGE_SIZE: type('[sites] Change Page Size'),
  PAGE_TO: type('[sites] Page To'),
  ORDER_BY: type('[sites] Order By'),
  LOAD: type('[sites] Load'),
  LOAD_SUCCESS: type('[sites] Load Success'),
  LOAD_FAIL: type('[sites] Load Fail'),
  SELECT_PAGE: type('[sites] Select Page'),
  UNSELECT_PAGE: type('[sites] Unselect Page'),
  TOGGLE_SELECTION: type('[sites] Toggle Selection'),
  TOGGLE_SELECTION_TAGS: type('[sites] Toggle Selection Tags'),
  CLEAR: type('[sites] Clear Data'),
  CLEAR_SELECTED: type('[sites] Clear Selected Data'),
  EXPORT_ALL_SITES: type('[sites] Export All sites'),
  EXPORT_ALL_SITES_SUCCESS: type('[sites] Export All sites Success'),
};


export class ToggleSearchSitesAction implements Action {
  readonly type = siteListActionTypes.TOGGLE_SEARCH;
  constructor(public payload?: boolean) {}
}

export class QuickSearchSitesAction implements Action {
  readonly type = siteListActionTypes.QUICK_SEARCH;
  constructor(public payload?: string) {}
}

export class SearchSitesAction implements Action {
  readonly type = siteListActionTypes.SEARCH;
  constructor(public payload?: SiteFilter | string | number) {}
}

export class ChangeSitesPageSizeAction implements Action {
  readonly type = siteListActionTypes.CHANGE_PAGE_SIZE;
  constructor(public payload?: number) {}
}

export class PageSitesToAction implements Action {
  readonly type = siteListActionTypes.PAGE_TO;
  constructor(public payload?: number) {}
}

export class OrderSitesByAction implements Action {
  readonly type = siteListActionTypes.ORDER_BY;
  constructor(public payload?: string) {}
}

export class LoadSitesAction implements Action {
  readonly type = siteListActionTypes.LOAD;
  constructor() {}
}

export class LoadSitesSuccessAction implements Action {
  readonly type = siteListActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ArrayResponse<Site>) {}
}

export class LoadSitesFailAction implements Action {
  readonly type = siteListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class SelectSitesPageAction implements Action {
  readonly type = siteListActionTypes.SELECT_PAGE;
  constructor() {}
}

export class UnselectSitesPageAction implements Action {
  readonly type = siteListActionTypes.UNSELECT_PAGE;
  constructor() {}
}
export class ToggleSitesSelectionAction implements Action {
  readonly type = siteListActionTypes.TOGGLE_SELECTION;
  constructor(public payload?: SelectedItem) {}
}
export class ClearSitesAction implements Action {
  readonly type = siteListActionTypes.CLEAR;
  constructor() {}
}
export class ClearSelectedSitesAction implements Action {
  readonly type = siteListActionTypes.CLEAR_SELECTED;
  constructor() {}
}
export class ExportExcelAllSitesAction implements Action {
  readonly type = siteListActionTypes.EXPORT_ALL_SITES;
  constructor() {}
}
export class ExportExcelAllSitesSuccessAction implements Action {
  readonly type = siteListActionTypes.EXPORT_ALL_SITES_SUCCESS;
  constructor() {}
}
